import { SupportedChainId } from './chain'

export const ZOOM_2_ADDRESSES = {
    [SupportedChainId.MAINNET]: "0x7cdF091AF6a9ED75E3192500d3e5BB0f63e22Dea",
    [SupportedChainId.GOERLI]:  "0xebC7d793d062371C11cB802e7D49eEAA0c30EB06",
    [SupportedChainId.POLYGON]: "0x40faA8d164973Ab39F3cBf6e3876a3130F9c6C77",
    [SupportedChainId.MUMBAI]:  "0x5EB2a698585BE438dF35ac667e9A502C983fe2b3"
}

export const ERC1820_REGISTRY_ADDRESS = "0x1820a4B7618BdE71Dce8cdc73aAB6C95905faD24";
